import React, { useEffect, useState, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Grid,
  Breadcrumbs,
  Link,
  Grow,
  Typography,
  IconButton,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useParams } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
// import required modules
import { Navigation } from "swiper";
import { numberToIndianRupee } from "utils/numberToIndianRupee";
import ImageMagnify from "react-image-magnify";
import AppointmentModal from "pages/products/appointmentModal";
import productsApi from "services/products";
import homeApi from "services/home";
import { showLoader, hideLoader } from "redux/loader/actions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { API_ENDPOINTS } from "constants";
import { useNavigate } from "react-router-dom";

import VisibilitySensor from "react-visibility-sensor";

const products = [
  {
    // General details
    id: 1,
    name: "Sparkle Multi Stone Gold Earrings",
    img: "/assets/images/products/earrings.webp",
    mainCategory: "gold",
    subCategory: "earrings",
    ocassion: "casual",
    gender: "female",
    productImages: [
      { path: "/assets/images/products/earrings1.webp", isActive: false },
      { path: "/assets/images/products/earrings2.webp", isActive: false },
      { path: "/assets/images/products/earrings3.webp", isActive: false },
    ],
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 10,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 10,
    gstFinalValue: 780,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 2,
    name: "Multi Stone Gold Bangles",
    img: "/assets/images/products/bangles.webp",
    mainCategory: "gold",
    subCategory: "bangles",
    ocassion: "party",
    gender: "female",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 3,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 3,
    name: "Geometric Diamond Bracelet",
    img: "/assets/images/products/bracelets.webp",
    mainCategory: "diamond",
    subCategory: "bracelets",
    ocassion: "party",
    gender: "unisex",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 5,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 4,
    name: "22KT Gold 2 Grams Leaf Coin",
    img: "/assets/images/products/coin.webp",
    mainCategory: "gold",
    subCategory: "coins",
    ocassion: "casual",
    gender: "unisex",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 5,
    name: "Dainty Floral Mangalsutra",
    img: "/assets/images/products/mangalsutras.webp",
    mainCategory: "diamond",
    subCategory: "mangalsutra",
    ocassion: "casual",
    gender: "unisex",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 6,
    name: "Twilight Dream Necklace",
    img: "/assets/images/products/necklace.webp",
    mainCategory: "diamond",
    subCategory: "necklace",
    ocassion: "casual",
    gender: "female",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 15,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 7,
    name: "Elaborate 22 Karat Yellow Gold Floral Nath",
    img: "/assets/images/products/nosepins.webp",
    mainCategory: "silver",
    subCategory: "nosepins",
    ocassion: "casual",
    gender: "female",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 8,
    name: "Beauty Color Stone Floral Gold Pendants",
    img: "/assets/images/products/pendant.webp",
    mainCategory: "silver",
    subCategory: "pendant",
    ocassion: "casual",
    gender: "female",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 7,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 9,
    name: "Gorgeous Floral Gold Rings",
    img: "/assets/images/products/weddingring.webp",
    mainCategory: "platinum",
    subCategory: "weddingring",
    ocassion: "traditional",
    gender: "unisex",
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
];

const ProductDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { productId: pId } = useParams();
  const dispatch = useDispatch();
  const productDetailsRef = useRef(null);
  const contactDetails = useSelector(
    (state) => state?.contactDetailsReducer?.contactDetails?.contactDetails
  );
  const phoneNumber = `91${contactDetails?.whatsappNo}` || "";

  const [productId, setProductId] = useState(pId);
  const [productDetails, setProductDetails] = useState(null);
  const [currentSlideImg, setCurrentSlideImg] = useState(null);
  const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
  const [price, setPrice] = useState(0);
  const [wastageOptions, setWastageOptions] = useState([]);
  const [purityOptions, setPurityOptions] = useState([]);
  const [purity, setPurity] = useState([]);
  const [ocassionOptions, setOcassionOptions] = useState([]);
  const [ocassion, setOcassion] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [gender, setGender] = useState([]);
  const [gramOptions, setGramOptions] = useState([]);
  const [gram, setGram] = useState(null);
  const [rate, setRate] = useState(0);
  const [metalRateOptions, setMetalRateOptions] = useState([]);
  const [whatsAppMessage, setWhatsAppMessage] = useState("Send Hi to start");
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    whatsAppMessage
  )}`;

  const [productList, setProductList] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const [params, setParams] = useState({
    category_id: "",
    subCategory_id: "",
    occasion: "",
    // purity: '',
    weightRange: "",
    gender: "",
    productstyle: "",
    // page: 1,
    // limit: 10,
  });
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    limit: 12,
  });

  const onVisibilityChange = (isVisible) => {
    setIsVisible(isVisible);
  };

  // Handle appointment modal
  const handleOpenAppointmentModal = () => {
    setOpenAppointmentModal(true);
  };
  const handleCloseAppointmentModal = () => {
    setOpenAppointmentModal(false);
  };

  const getSubCategory = useCallback(
    (id) => {
      dispatch(showLoader("Loading please wait..."));
      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status?.toLowerCase() === "true") {
          const addedTabValuesArr = res?.data?.data?.results?.map(
            (data, idx) => ({ ...data, tabIndex: idx })
          );
          setProductList(res?.data?.data);
          // setMainCategoryOptions(addedTabValuesArr)
        } else {
          setProductList([]);
          // setMainCategoryOptions([])
        }
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        console.log("Get sub category options Api", err);
      };
      _.isEmpty(
        _.pickBy(
          params,
          (value) => value != null && value !== "" && value !== undefined
        )
      )
        ? dispatch(hideLoader())
        : productsApi
            .getProductsList(params, paginationParams)
            .then(onSuccess, onFailure);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [params.category_id, params.subCategory_id, paginationParams]
  );

  // useEffect(() => {
  //   const findProduct = products?.find(
  //     (data) => data?.id === parseInt(productId)
  //   )
  //   findProduct && setProductDetails(findProduct)
  //   setCurrentSlideImg(findProduct?.productImages?.[0]?.path)
  // }, [productId])

  const handleNavigateProductDetails = () => {
    productDetailsRef.current.scrollIntoView({ behavior: "smooth" });
  };

  // Get today metal rates api
  const getMetalRates = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status?.toLowerCase() === "true") {
        setMetalRateOptions(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log("Get today metal rates Api", err);
    };
    homeApi.getTodayRates().then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getMetalRates();
  }, [getMetalRates]);

  //Get wastage options api
  const getWastageOptions = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status?.toLowerCase() === "true") {
        setWastageOptions(res?.data?.data?.results);
      } else {
        setWastageOptions([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log("Get wastage options Api", err);
    };
    productsApi.getWastageList().then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getWastageOptions();
  }, [getWastageOptions]);

  //Get ocassion filter options options api
  const getOcassionOptions = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status?.toLowerCase() === "true") {
        setOcassionOptions(res?.data?.data?.results);
      } else {
        setOcassionOptions([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log("Get ocassion filter options Api", err);
    };
    productsApi.getOcassionList().then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getOcassionOptions();
  }, [getOcassionOptions]);

  //Get purity filter options api
  const getPurityOptions = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status?.toLowerCase() === "true") {
        setPurityOptions(res?.data?.data?.results);
      } else {
        setPurityOptions([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log("Get purity filter options Api", err);
    };
    productsApi.getPurityList().then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getPurityOptions();
  }, [getPurityOptions]);

  //Get gender filter options api
  const getGenderFilter = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status?.toLowerCase() === "true") {
        setGenderOptions(res?.data?.data?.results);
      } else {
        setGenderOptions([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log("Get gender filter options Api", err);
    };
    productsApi.getGenderList().then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getGenderFilter();
  }, [getGenderFilter]);

  //Get weight range grams filter options api
  // const getWeightRangeFilter = useCallback(() => {
  //   dispatch(showLoader('Loading please wait...'))
  //   const onSuccess = (res) => {
  //     dispatch(hideLoader())
  //     if (res?.data?.status?.toLowerCase() === 'true') {
  //       setGramOptions(res?.data?.data?.results)
  //     } else {
  //       setGramOptions([])
  //     }
  //   }
  //   const onFailure = (err) => {
  //     dispatch(hideLoader())
  //     console.log('Get weight range filter options Api', err)
  //   }
  //   productsApi.getWeightRangeList().then(onSuccess, onFailure)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  // useEffect(() => {
  //   getWeightRangeFilter()
  // }, [getWeightRangeFilter])

  //Get product details by id api
  const getProductDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status?.toLowerCase() === "true") {
        setProductDetails(res?.data?.data || null);
        setCurrentSlideImg(res?.data?.data?.image?.[0]?.filename);
        setPrice(res?.data?.data?.price);
        setPurity(res?.data?.data?.productstyle?.purity);
        setOcassion(res?.data?.data?.productstyle?.occasion);
        setGender(res?.data?.data?.productstyle?.gender);
        setGramOptions(res?.data?.data?.weightRanges);
        setGram(res?.data?.data?.weightRange || null);
        setParams((prev) => ({
          ...prev,
          category_id: res?.data?.data?.category_id._id,
          subCategory_id: res?.data?.data?.subCategory_id?._id,
          productstyle: res?.data?.data?.productstyle?._id,
        }));
      } else {
        setProductDetails([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log("Get product details Api", err);
    };
    productsApi
      .getProductById(productId)
      .then(onSuccess, onFailure)
      .finally(() => window.scrollTo({ top: 0, behavior: "smooth" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);
  useEffect(() => {
    getProductDetails();
  }, [getProductDetails]);

  // set purity , ocassion , gender
  // useEffect(() => {
  //   const purity = purityOptions?.find(
  //     (data) => data?._id === productDetails?.productstyle?.purity
  //   )
  //   purity && setPurity(purity)
  //   const ocassion = ocassionOptions?.find(
  //     (data) => data?._id === productDetails?.productstyle?.occasion
  //   )
  //   ocassion && setOcassion(ocassion)
  //   const gender = genderOptions?.find(
  //     (data) => data?._id === productDetails?.productstyle?.gender
  //   )
  //   gender && setGender(gender)
  // }, [ocassionOptions, productDetails, purityOptions, genderOptions])

  // set gram
  // useEffect(() => {
  //   if (gramOptions) {
  //     let smallestValue = Infinity

  //     for (let i = 0; i < gramOptions.length; i++) {
  //       const value = gramOptions[i].value
  //       if (value < smallestValue) {
  //         smallestValue = value
  //       }
  //     }
  //     const findGram = gramOptions?.find(
  //       (data) => data?.value === smallestValue
  //     )
  //     findGram && setGram(findGram)
  //   }
  // }, [productDetails, gramOptions])

  // change price according to gram onchange
  // useEffect(() => {
  //   const rate = productDetails?.rate?.rate
  //   const weight = gram?.value
  //   const wastage = wastageOptions?.find(
  //     (data) => data?._id === productDetails?.productstyle?.wastage
  //   )
  //   if (rate && wastage && weight) {
  //     const currentWastagePercentRate =
  //       (rate / 100) * parseFloat(wastage?.wastage)
  //     const calculatePrice = rate * weight + currentWastagePercentRate
  //     calculatePrice && setPrice(parseFloat(calculatePrice))
  //   }
  // }, [productDetails, wastageOptions, gram])

  // Handle Virtual Tryon
  const loadMirrarUI = (sku) => {
    let script = document.createElement("script");
    script.onload = () => {
      // Define your options
      let options = {
        brandId: "70fa3fe5-aefe-43bb-8c6b-8783277fe33f",
      };
      // Call the Mirrar UI initialization function
      window.initMirrarUI(sku, options);
    };
    script.src = "https://cdn.mirrar.com/general/scripts/mirrar-ui.js";
    document.body.appendChild(script);
  };

  // Set current rate based on main category
  useEffect(() => {
    if (!_.isEmpty(productDetails?.category_id)) {
      const metalRate = metalRateOptions?.find(
        (data) => data?.category?._id === productDetails?.category_id?._id
      );

      metalRate && setRate(metalRate?.rate);
    }
  }, [productDetails, metalRateOptions]);

  useEffect(() => {
    return () => {
      // Clean up any resources when the component unmounts
      // (e.g., remove event listeners, clear timeouts/intervals)
      // Here, you can remove the Mirrar UI script if needed
      let mirrarScript = document.querySelector(
        "script[src^='https://cdn.mirrar.com/general/scripts/mirrar-ui.js']"
      );
      if (mirrarScript) {
        mirrarScript.remove();
      }
    };
  }, []);

  const handleVirtualTryon = (sku) => {
    loadMirrarUI(sku);
  };

  // Set whatsapp message
  useEffect(() => {
    setWhatsAppMessage(
      `Hello, I would like to inquire about the ${productDetails?.category_id?.name} ${productDetails?.name} with the product code - ${productDetails?.skuid}`
    );
  }, [productDetails]);

  useEffect(() => {
    getSubCategory();
  }, [params.category_id, params.subCategory_id, paginationParams]);

  return (
    <>
      <Grid container className={classes.root}>
        {/* Breadcrumbs */}
        <Grid item xs={12} className={classes.breadcrumbs}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={`/shop/${productDetails?.category_id?.name?.toLowerCase()}`}
            >
              {productDetails?.category_id?.name}
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={`/shop/${productDetails?.category_id?.name?.toLowerCase()}/${productDetails?.subCategory_id?.name?.toLowerCase()}`}
            >
              {productDetails?.subCategory_id?.name}
            </Link>
            <Typography variant="body1">
              {productDetails?.productstyle?.name}
            </Typography>
            {/* <Typography variant="body1">{productDetails?.name}</Typography> */}
          </Breadcrumbs>
        </Grid>
        {/* Product details */}
        <Grid item xs={12} className={classes.productWrapper}>
          {/* Product Image container */}
          <Grid item xs={12} md={5} className={classes.productImgWrapper}>
            <section className={classes.productImgContainer}>
              {/* <img
                src={API_ENDPOINTS.FILE_URL + currentSlideImg}
                alt={productDetails?.title}
                className={classes.productImg}
              /> */}
              {currentSlideImg ? <ImageMagnify
                {...{
                  smallImage: {
                    className: `${classes?.productImg}`,
                    alt: `${productDetails?.name || "product Image"}`,
                    // isFluidWidth: true,
                    src: `${API_ENDPOINTS.FILE_URL + currentSlideImg}`,
                    width: 340,
                    height: 320,
                    margin: "auto",
                  },
                  largeImage: {
                    src: `${API_ENDPOINTS.FILE_URL + currentSlideImg}`,
                    width: 1200,
                    height: 1000,
                  },
                  isHintEnabled: true,
                  zoomFactor: 2,
                }}
                style={{ margin: "auto" }}
                enlargedImageStyle={{
                  backgroundColor: "white",
                }}
              />  : (
                <div
                  className={"cover-image-skeleton"}
                ></div>
              )}
            </section>
            <section className={classes.sliderWrapper}>
              <section className="prev-sml">
                <IconButton sx={{ background: "#fff" }}>
                  <KeyboardArrowLeftOutlinedIcon className={classes.icon} />
                </IconButton>
              </section>
              <Swiper
                navigation={{
                  prevEl: ".prev-sml",
                  nextEl: ".next-sml",
                  clickable: true,
                }}
                slidesPerView={5}
                modules={[Navigation]}
                grabCursor={true}
                className="mySwiper"
                spaceBetween={16}
              >
                {productDetails?.image?.map((data, idx) => (
                    <SwiperSlide key={idx}>
                      <div
                        className={classes.imgContainer}
                        onClick={() => setCurrentSlideImg(data?.filename)}
                      >
                        <img
                          src={API_ENDPOINTS.FILE_URL + data?.filename}
                          alt="slider"
                          className={classes.productSlideImg}
                        />
                      </div>
                    </SwiperSlide>
                ))}
              </Swiper>
              <section className="next-sml">
                <IconButton sx={{ background: "#fff" }}>
                  <KeyboardArrowRightOutlinedIcon className={classes.icon} />
                </IconButton>
              </section>
            </section>
            {/* <div className={classes.tryOnBtn}>
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => handleVirtualTryon(productDetails?.skuid)}
              >
                Try It On
              </Button>
            </div> */}
          </Grid>
          {/* Product content container */}
          <Grid item xs={12} md={7} className={classes.contentContainer}>
            <Grid item xs={12} className={classes.productName}>
              <Typography variant="h2">{productDetails?.name}</Typography>
            </Grid>
            {/* <Grid item xs={12} className={classes.productSubCategoryWrapper}>
              <Typography variant="h6">{productDetails?.productstyle?.name}</Typography>
            </Grid> */}
            <div className={classes.productSkuid}>
              <Typography variant="body2">
                <b>SKUID: </b>
                {productDetails?.skuid}
              </Typography>
            </div>
            {/* <Grid item xs={12} className={classes.productWeight}>
              <Typography variant="body2">Gross weight :</Typography>
              <section className={classes.autocomplete}>
                <Autocomplete
                  disablePortal
                  disableClearable
                  fullWidth
                  size="small"
                  name="gram"
                  id="gram"
                  options={gramOptions}
                  value={gram}
                  getOptionLabel={(option) => option.value || ''}
                  onChange={(e, value) => {
                    setGram(value)
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <Typography variant="body2">{option?.value}g</Typography>
                    </li>
                  )}
                />
              </section>
            </Grid> */}
            <Grid item xs={12} className={classes.productPriceWrapper}>
              {/* <div className={classes.productSellingPrice}>
                <Typography variant="h6">
                  &#x20b9; {numberToIndianRupee(gram?.value * rate)}
                </Typography>
              </div> */}
              {/* <div className={classes.productActualPrice}>
                <Typography variant="h6">
                  &#x20b9; {productDetails?.metalMrp}
                </Typography>
              </div> */}
              {/* <div className={classes.productDiscount}>
                <Typography variant="h6">(7% OFF)</Typography>
              </div> */}

              {/* Product details table */}
              <Grid item xs={12} className={classes.productDetailsContainer}>
                {/* <Grid item xs={12} className={classes.detailsLabel}>
            <Typography variant="h3">Product Details</Typography>
          </Grid> */}
                <Grid
                  item
                  xs={12}
                  className={classes.detailsTabelContainer}
                  ref={productDetailsRef}
                >
                  <Grid item xs={12} className={classes.title}>
                    <Typography variant="h5">Product Description</Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.description}>
                    <Typography variant="body2">
                      {productDetails?.description}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.labelWrapper}>
                    <Grid item className={classes.key}>
                      <Typography variant="body2">Metal</Typography>
                    </Grid>
                    <Grid item className={classes.value1}>
                      <Typography variant="body2">
                        {" "}
                        {productDetails?.category_id?.name}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.labelWrapper}>
                    {" "}
                    <Grid item className={classes.key}>
                      <Typography variant="body2">Product</Typography>
                    </Grid>
                    <Grid item className={classes.value1}>
                      <Typography variant="body2">
                        {" "}
                        {productDetails?.subCategory_id?.name}
                        {!productDetails?.name ? ""  : ' - ' +  productDetails?.name}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.labelWrapper}>
                    {" "}
                    <Grid item className={classes.key}>
                      <Typography variant="body2">Ocassion</Typography>
                    </Grid>
                    <Grid item className={classes.value1}>
                      <Typography variant="body2">{ocassion?.name}</Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.labelWrapper}>
                    {" "}
                    <Grid item className={classes.key}>
                      <Typography variant="body2">Gender</Typography>
                    </Grid>
                    <Grid item className={classes.value1}>
                      <Typography variant="body2">
                        {gender?.gendername}
                      </Typography>
                    </Grid>
                  </Grid>
                  {!_.isEmpty(productDetails?.productstyle?.length) && (
                    <Grid item xs={12} className={classes.labelWrapper}>
                      {" "}
                      <Grid item className={classes.key}>
                        <Typography variant="body2">Length</Typography>
                      </Grid>
                      <Grid item className={classes.value1}>
                        <Typography variant="body2">
                          {productDetails?.productstyle?.length}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}

                  {!_.isEmpty(productDetails?.productstyle?.size) && (
                    <Grid item xs={12} className={classes.labelWrapper}>
                      {" "}
                      <Grid item className={classes.key}>
                        <Typography variant="body2">Size</Typography>
                      </Grid>
                      <Grid item className={classes.value1}>
                        <Typography variant="body2">
                          {productDetails?.productstyle?.size}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  {productDetails?.productstyle?.estimatedDays && (
                    <Grid item xs={12} className={classes.labelWrapper}>
                      {" "}
                      <Grid item className={classes.key}>
                        <Typography variant="body2">
                          Jewel Crafting Duration
                        </Typography>
                      </Grid>
                      <Grid item className={classes.value1}>
                        <Typography variant="body2">
                          {productDetails?.productstyle?.estimatedDays} days
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  {!gram || !gramOptions?.length ? null : (
                    <Grid item xs={12} className={classes.labelWrapper}>
                      <Grid item className={classes.key}>
                        <Typography variant="body2">Weight Options</Typography>
                      </Grid>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "fit-content",
                          flexWrap: "wrap",
                          bgcolor: "background.paper",
                          color: "text.secondary",
                          "& svg": {
                            m: 1.5,
                          },
                          "& hr": {
                            mx: 0.5,
                          },
                        }}
                      >
                        {gramOptions?.map((opt, index) => (
                          <>
                            <Grid
                              key={opt?.value}
                              item
                              className={
                                opt._id === gram
                                  ? classes.activeOptionList
                                  : classes.optionList
                              }
                            >
                              <Typography variant="body2">
                                {opt.range || (opt.value + "grams")}
                              </Typography>
                            </Grid>
                          </>
                        ))}
                      </Box>
                    </Grid>
                  )}
                  {productDetails?.subCategory_id?.size == "" || !productDetails?.subCategory_id?.size?.split(",")
                    ?.length ? null : (
                    <Grid item xs={12} className={classes.labelWrapper}>
                      <Grid item className={classes.key}>
                        <Typography variant="body2">Size Options</Typography>
                      </Grid>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "fit-content",
                          flexWrap: "wrap",
                          bgcolor: "background.paper",
                          color: "text.secondary",
                          "& svg": {
                            m: 1.5,
                          },
                          "& hr": {
                            mx: 0.5,
                          },
                        }}
                      >
                        {productDetails?.subCategory_id?.size
                          ?.split(",")
                          ?.map((opt, index) => (
                            <>
                              <Grid
                                key={opt}
                                item
                                className={classes.optionList}
                              >
                                <Typography variant="body2">{opt}</Typography>
                              </Grid>
                            </>
                          ))}
                      </Box>
                    </Grid>
                  )}
                  {productDetails?.subCategory_id?.length == "" || !productDetails?.subCategory_id?.length?.split(",")
                    ?.length ? null : (
                    <Grid item xs={12} className={classes.labelWrapper}>
                      <Grid item className={classes.key}>
                        <Typography variant="body2">Length Options</Typography>
                      </Grid>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "fit-content",
                          flexWrap: "wrap",
                          bgcolor: "background.paper",
                          color: "text.secondary",
                          "& svg": {
                            m: 1.5,
                          },
                          "& hr": {
                            mx: 0.5,
                          },
                        }}
                      >
                        {productDetails?.subCategory_id?.length
                          ?.split(",")
                          ?.map((opt, index) => (
                            <>
                              <Grid
                                key={opt}
                                item
                                className={classes.optionList}
                              >
                                <Typography variant="body2">{opt}</Typography>
                              </Grid>
                            </>
                          ))}
                      </Box>
                    </Grid>
                  )}
                  {/* <Grid item xs={12} className={classes.title}>
              <Typography variant="h5">Price Breakup</Typography>
            </Grid>
            <Grid item xs={12} className={classes.table}>
              <Grid item xs={12} className={classes.tableHeaderWrapper}>
                <section className={classes.component}>
                  <div className={classes.tableHeaderLabel}>
                    <Typography variant="body1">Component</Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div className={classes.tableHeaderLabel}>
                    <Typography variant="body1">Rate</Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div className={classes.tableHeaderLabel}>
                    <Typography variant="body1">Weight</Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div className={classes.tableHeaderLabel}>
                    <Typography variant="body1">Value</Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div className={classes.tableHeaderLabel}>
                    <Typography variant="body1">Discount</Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div className={classes.tableHeaderLabel}>
                    <Typography variant="body1">Final Value</Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2">Gold</Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2">91.6 Gold</Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div>
                    <Typography variant="body2">5650</Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div>
                    <Typography variant="body2">38.407</Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div>
                    <Typography variant="body2">&#x20b9;217,000</Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div>
                    <Typography variant="body2">-</Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div>
                    <Typography variant="body2">&#x20b9;217,000</Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2">Stone Details</Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2">901 1Nos.</Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div>
                    <Typography variant="body2">4.2500</Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div>
                    <Typography variant="body2">&#x20b9;1,912</Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div>
                    <Typography variant="body2">-</Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div>
                    <Typography variant="body2">&#x20b9;1,912</Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      Total Stone Value
                    </Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      &#x20b9;1,912
                    </Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div>
                    <Typography variant="body2">-</Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      &#x20b9;1,912
                    </Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2">Making Charges</Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div>
                    <Typography variant="body2">&#x20b9;47,306</Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div>
                    <Typography variant="body2">&#x20b9;9,461</Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div>
                    <Typography variant="body2">&#x20b9;37,845</Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      Total
                    </Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      &#x20b9;266,218
                    </Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div>
                    <Typography variant="body2"> &#x20b9;9,461 </Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      &#x20b9;256,757
                    </Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2">GST (3%)</Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div>
                    <Typography variant="body2">&#x20b9;7,987</Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div>
                    <Typography variant="body2">-</Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div>
                    <Typography variant="body2">&#x20b9;7,703</Typography>
                  </div>
                </section>
              </Grid>
              <Grid item xs={12} className={classes.tableRow}>
                <section className={classes.component}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      Grand Total
                    </Typography>
                  </div>
                </section>{' '}
                <section className={classes.rate}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.weight}>
                  <div>
                    <Typography variant="body2"></Typography>
                  </div>
                </section>{' '}
                <section className={classes.value}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      &#x20b9;274,205
                    </Typography>
                  </div>
                </section>{' '}
                <section className={classes.discount}>
                  <div>
                    <Typography variant="body2">- </Typography>
                  </div>
                </section>{' '}
                <section className={classes.finalValue}>
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      &#x20b9;264,460
                    </Typography>
                  </div>
                </section>
              </Grid>
            </Grid> */}
                </Grid>
              </Grid>
            </Grid>
            {/* <div className={classes.productGst}>
              <Typography variant="body2">
                (Exclusive of gst and making charges)
              </Typography>
            </div>
            <Grid item xs={12} className={classes.productWeight}>
              <Typography variant="body2">Gross weight :</Typography>
              <section className={classes.autocomplete}>
                <Autocomplete
                  disablePortal
                  disableClearable
                  fullWidth
                  size="small"
                  name="gram"
                  id="gram"
                  options={gramOptions}
                  value={gram}
                  getOptionLabel={(option) => option.value || ''}
                  onChange={(e, value) => {
                    setGram(value)
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <Typography variant="body2">{option?.value}g</Typography>
                    </li>
                  )}
                />
              </section>
            </Grid>
            {!_.isEmpty(purity?.puritytype) && (
              <Grid item xs={12} className={classes.productPurity}>
                <Typography variant="body2">
                  <span style={{ textTransform: 'capitalize' }}>
                    {productDetails?.category_id?.name} purity :
                  </span>{' '}
                  ({purity?.puritytype}) Karat
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} className={classes.productDetailsLink}>
              <Typography
                variant="body2"
                onClick={handleNavigateProductDetails}
              >
                View product details
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.appointmentBtn}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleOpenAppointmentModal()}
              >
                Book an appointment
              </Button>
            </Grid>
            <Grid item xs={12} className={classes.whatsAppWrapper}>
              <Typography variant="body2">Have Questions? Whatsapp</Typography>
              <div className={classes.whatsAppNoWrapper}>
                <WhatsAppIcon />{' '}
                <div className={classes.whatsAppNo}>
                  <Typography
                    variant="body2"
                    onClick={() => window.open(url, '_blank')}
                  >
                    +91{contactDetails?.whatsappNo}
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.featuresWrapper}>
              <div className={classes.featuresWrapper}>
                <img
                  src="/assets/images/products/bis.png"
                  alt="bis"
                  width={26}
                  height={26}
                />
                <Typography variant="body2">BIS Hallmark Jewellery</Typography>
              </div>{' '}
              <div className={classes.featuresWrapper}>
                <img
                  src="/assets/images/products/exchange.png"
                  alt="bis"
                  width={26}
                  height={26}
                />
                <Typography variant="body2">Life Time Exchange</Typography>
              </div>{' '}
              <div className={classes.featuresWrapper}>
                <img
                  src="/assets/images/products/return.png"
                  alt="bis"
                  width={26}
                  height={26}
                />
                <Typography variant="body2">30 days return</Typography>
              </div>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
      <AppointmentModal
        open={openAppointmentModal}
        handleClose={handleCloseAppointmentModal}
        title="Book Appointment"
        btnLabel="Submit"
        productId={productId}
      />
      <Grid container className={classes.relRoot}>
        <Grid item xs={12} className={classes.relTitle}>
          <Typography variant="h2">Related Products</Typography>
        </Grid>
        <Grid item xs={12}>
          <section>
            {_.isEmpty(
              productList?.filter(
                (data) => data.productid !== productDetails._id
              ) ?? []
            ) ? (
              <>
                {" "}
                <div className={classes.emptyData}>
                  <Typography variant="h6">No Related Products...!</Typography>
                </div>{" "}
              </>
            ) : (
              <VisibilitySensor
                onChange={onVisibilityChange}
                partialVisibility={true}
              >
                <section className={classes.relSliderWrapper}>
                  <section className="prev">
                    <IconButton
                      sx={{ background: "#fff" }}
                      size="small"
                      component="div"
                    >
                      <KeyboardArrowLeftOutlinedIcon className={classes.icon} />
                    </IconButton>
                  </section>
                  <Swiper
                    navigation={{
                      prevEl: ".prev",
                      nextEl: ".next",
                      clickable: true,
                    }}
                    slidesPerView={5}
                    // navigation={true}
                    modules={[Navigation]}
                    grabCursor={true}
                    className="mySwiper"
                    spaceBetween={16}
                    breakpoints={{
                      50: {
                        slidesPerView: 1,
                      },
                      370: {
                        slidesPerView: 2,
                      },
                      600: {
                        slidesPerView: 3,
                      },
                      900: {
                        slidesPerView: 4,
                      },
                      1200: {
                        slidesPerView: 5,
                      },
                    }}
                  >
                    {productList
                      ?.filter((data) => data.productid !== productDetails._id)
                      ?.map((data) => (
                        <SwiperSlide key={data?.productid}>
                          {/* <Grow in={isVisible} timeout={1500} unmountOnExit> */}
                          <Grow in={true} timeout={1500} unmountOnExit>
                            <section
                              className={classes.cardWrapper}
                              onClick={() => {
                                data?.productid &&
                                  setProductId(data?.productid);
                              }}
                            >
                              <div className={classes.relImgContainer}>
                                <img
                                  src={
                                    API_ENDPOINTS?.FILE_URL +
                                    data?.image?.[0]?.filename
                                  }
                                  alt={data?.name}
                                  className={classes.sliderImg}
                                />
                              </div>
                              <div className={classes.label}>
                                <Typography variant="body1">
                                  {data?.name}
                                </Typography>
                              </div>
                            </section>
                          </Grow>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                  <section className="next">
                    <IconButton
                      sx={{ background: "#fff" }}
                      size="small"
                      component="div"
                    >
                      <KeyboardArrowRightOutlinedIcon
                        className={classes.icon}
                      />
                    </IconButton>
                  </section>
                </section>
              </VisibilitySensor>
            )}
          </section>
        </Grid>
      </Grid>
    </>
  );
};

export default ProductDetails;
